import { selectors as authSelectors } from '@hixme/auth-ui'
import {
  ROLE_CLIENT_ADMIN,
  ROLE_PLATFORM_HIXME_ADMIN,
} from '@hixme/role-policy'
import { useSelector } from 'react-redux'

import { GLOBAL_FLAG_KEY } from 'constants/globalFlag'
import useCustomerConfigurationFlag from 'hooks/useCustomerConfigurationFlag'
import useGlobalFlag from 'hooks/useGlobalFlag'
import { selectors as userSessionSelectors } from 'store/modules/user-session'

import { RECRUITING_CLIENT_ADMIN_FLAG } from '../constants'

interface UseRecruitingAccessReturn {
  hasAccess: boolean
  isAccessLoading: boolean
}

/**
 * Recruiting access is role-split:
 * - Platform Hixme admins → global flag `admin.recruiting.enable-for-hr-admins`
 * - HR client admins → customer config `admin.recruiting.enable-for-client-admins`
 */
export function useRecruitingAccess(): UseRecruitingAccessReturn {
  const role = useSelector(authSelectors.getRole)
  const currentSelectedCompanyId = useSelector(
    userSessionSelectors.getCurrentCompanyId
  )

  const isPlatformAdmin = role === ROLE_PLATFORM_HIXME_ADMIN
  const isHrAdmin = role === ROLE_CLIENT_ADMIN

  const {
    isEnabled: isRecruitingGlobalEnabled,
    isLoading: isRecruitingGlobalLoading,
  } = useGlobalFlag(GLOBAL_FLAG_KEY.RECRUITING_HR)

  const {
    isEnabled: isRecruitingClientEnabled,
    isLoading: isRecruitingClientLoading,
  } = useCustomerConfigurationFlag(
    isHrAdmin ? currentSelectedCompanyId : undefined,
    RECRUITING_CLIENT_ADMIN_FLAG
  )

  if (isPlatformAdmin) {
    return {
      hasAccess: isRecruitingGlobalEnabled,
      isAccessLoading: isRecruitingGlobalLoading,
    }
  }

  if (isHrAdmin) {
    return {
      hasAccess: isRecruitingClientEnabled,
      isAccessLoading: isRecruitingClientLoading,
    }
  }

  return {
    hasAccess: false,
    isAccessLoading: false,
  }
}
